export default {"src":"/_next/static/media/audr.28452118.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};